// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","nav":"Header_nav__J8WFt","logo":"Header_logo__UsziS","arrow":"Header_arrow__UOjtE"};